module.exports = __webpack_public_path__ + "static/img/05.50560bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/05.png
// module id = 5odk
// module chunks = 0